import React from 'react';

class DomainList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToAdd: false
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({...nextProps});
  }

  addNewDomain () {
    this.setState({...this.state, redirectToAdd:true })
  }

  render() {
    if (this.props.domains) {
      const domains = this.props.domains.map((domain) =>
          <div>
          <div style={{ marginTop:8, marginBottom:10 }}>
            {domain}
            <a href={`http://${domain}`} target="_blank">view</a></div>
          </div>
      );

      return (
        <div>
          <ul className={'contentField-container'}>
            {domains}
          </ul>
        </div>
      );
    } else {
      return (
        <div></div>
      )
    }

  }
}

export default DomainList;



// WEBPACK FOOTER //
// ./src/components/DomainList.js